import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {RequesterService} from './requester.service';
import {NavController} from '@ionic/angular';
import {UserInfoModel} from './models/user-info.model';
import {EventsService} from './events.service';
import {JourneyDelegateTemplateModel} from '../modules/journey/models/journey-page.model';
import {TranslateService} from '@ngx-translate/core';
import {DelegateSimpleModel} from '../modules/team/models/delegate.model';
import {environment} from '../../environments/environment';
import {LocaleService} from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public langId = 1;
  public langUID = 'en';
  public langISOCode = 'en';
  public userInfo: UserInfoModel = null;
  public userTemplateId: number = null;
  public userDelegateTemplate: JourneyDelegateTemplateModel = null;

  public theme = 'default';
  public headerMode = 'dark'; // light
  public companyLogo = 'assets/icon/journey-logo.svg';
  public companyLogoSmall = 'assets/icon/alchemist-logo.svg';
  public companyLogoBottom = 'assets/icon/footer-logo.svg';
  public companyLogoSize = 'default';
  public companyHeader = 'default';

  private hash = 'Guest';

  constructor(
    private event: EventsService,
    private router: Router,
    private navCtrl: NavController,
    private requesterService: RequesterService,
    private translate: TranslateService,
    private localeService: LocaleService
  ) {
    this.theme = environment.theme;
    this.event.subscribe('logout', () => {
      this.langId = 1;
      this.langUID = 'en';
      this.langISOCode = 'en';
      this.userInfo = null;
      this.userTemplateId = null;
      this.userDelegateTemplate = null;
      this.theme = environment.theme;
      this.companyLogo = 'assets/icon/journey-logo.svg';
      this.companyLogoSize = 'default';
      this.companyHeader = 'default';
      this.companyLogoSmall = 'assets/icon/alchemist-logo.svg';
      this.companyLogoBottom = 'assets/icon/footer-logo.svg';
      this.headerMode = 'dark';

      this.translate.use(this.langUID);
      this.localeService.setLocale(this.langISOCode);
    });
  }

  getUserInfo(): Promise<UserInfoModel> {
    return this.requesterService.get('getCurrentUserInfo')
      .then(data => {
        if (!data.hasOwnProperty('result') || data.result === null) {
          this.userInfo = null;
          return null;
        }

        this.userInfo = data.result;
        this.hash = this.userInfo.id.toString();

        this.userTemplateId = +localStorage.getItem('userTemplateId[' + this.hash + ']') || null;
        this.setUserDelegateTemplate(this.userTemplateId);

        // if (['en', 'ILJA', 'LJA', 'VEEAM'].includes(this.userInfo.language.lang)) {
        if (!!this.userInfo.language && !!this.userInfo.language.lang) {
          this.langId = this.userInfo.language.id || 1;
          this.langUID = this.userInfo.language.lang || 'en';
          this.langISOCode = this.userInfo.language.code || 'en';

          this.translate.use(this.langUID);
          this.localeService.setLocale(this.langISOCode);
        }

        if (!this.userInfo.coach_type) {
          // TODO Display company icon for Black and White
          if (this.userInfo.client_id === 153) {
            this.theme = 'bnw';
            this.companyLogo = 'assets/theme/bnw/bnw-logo.jpg';
            this.companyHeader = 'bnw';
            this.companyLogoSize = 'bigger';
          } else if (this.userInfo.client_id === 134 || (this.userInfo.client_id === 165 && environment.websiteUrl === 'https://dev.my721.com')) {
            this.theme = 'twinings';
            // this.headerMode = 'light';
            // this.companyLogo = 'assets/icon/twinings-logo.png';
            this.companyLogo = 'assets/theme/twinings/twinings-logo2-2x.png';
            this.companyHeader = 'twinings';
            this.companyLogoSize = 'bigger';
          } else if (this.userInfo.client_id === 131) {
            this.theme = 'veeam';
            this.companyLogo = 'assets/theme/veeam/veeam-logo-2025.svg';
            this.companyHeader = 'veeam';
          } else if (this.userInfo.client_id === 132) {
            this.theme = 'cdw';
            this.companyLogo = 'assets/theme/cdw/cdw-logo-center.svg';
            this.companyHeader = 'cdw';
          } else if (this.userInfo.client_id === 157) {
            this.theme = 'marex';
            this.companyLogo = 'assets/icon/marex-logo.svg';
            this.companyHeader = 'marex';
          } else if (this.userInfo.client_id === 4) {
            this.theme = 'fugro';
            this.companyLogo = 'assets/icon/fugro-logo.svg';
            this.companyHeader = 'fugro';
            this.companyLogoSize = 'bigger';
          } else if (this.userInfo.client_id === 95) {
            this.theme = 'pmi';
            this.companyLogo = 'assets/icon/pmi-logo.svg';
            this.companyHeader = 'pmi';
            this.companyLogoSize = 'default';
          } else if (this.userInfo.client_id === 164) {
            this.theme = 'servicenow';
            this.companyLogo = 'assets/icon/servicenow-logo.svg';
            this.companyHeader = 'servicenow';
          } else if (this.userInfo.client_id === 167) {
            this.theme = 'jazzpharma';
            this.companyLogo = 'assets/theme/jazzpharma/jazzpharma-logo.svg';
            this.companyHeader = 'jazzpharma';
          } else if (this.userInfo.client_id === 80) {
            this.theme = 'bridgestone';
            this.companyLogo = 'assets/theme/bridgestone/bs-logo.png';
            this.companyHeader = 'bridgestone';
            this.companyLogoSize = 'bigger';
          } else if (this.userInfo.client_id === 180) {
            this.theme = 'quorum';
            this.companyLogo = 'assets/theme/quorum/quorum-logo.png';
            this.companyHeader = 'quorum';
          } else if (this.userInfo.client_id === 181) {
            this.theme = 'uhv-design';
            this.companyLogo = 'assets/theme/uhv-design/uhv-design-logo-cropped.png';
            this.companyHeader = 'uhv-design';
          } else if (this.userInfo.client_id === 189) {
            // this.theme = 'shoesmiths';
            this.companyLogo = 'assets/theme/shoesmiths/shoesmiths-logo.svg';
            // this.companyHeader = 'shoesmiths';
            this.companyLogoSize = 'smaller';
          } else if (this.userInfo.client_id === 193) {
            this.theme = 'atkinsrealis';
            this.companyLogo = 'assets/theme/atkinsrealis/logo-center.svg';
            this.companyLogoSmall = 'assets/theme/atkinsrealis/logo.svg';
            this.companyHeader = 'atkinsrealis';
            this.companyLogoSize = 'smaller';
          } else if (this.userInfo.client_id === 194) {
            this.theme = 'trane';
            this.companyLogo = 'assets/theme/trane/logo-center.svg';
            this.companyLogoSmall = 'assets/theme/trane/logo.svg';
            this.companyHeader = 'trane';
            this.companyLogoSize = 'default';
          } else if (this.userInfo.client_id === 196) {
            this.theme = 'seco';
            this.companyLogo = 'assets/theme/seco/logo-center.svg';
            this.companyLogoSmall = 'assets/theme/seco/logo.svg';
            this.companyLogoBottom = 'assets/theme/seco/logo-bottom.svg';
            this.companyHeader = 'seco';
            this.companyLogoSize = 'bigger';
          } else if (this.userInfo.client_id === 197) {
            this.theme = 'kindred';
            this.companyLogo = 'assets/theme/kindred/logo-center.svg';
            this.companyLogoSmall = 'assets/theme/kindred/logo.svg';
            this.companyHeader = 'kindred';
            this.companyLogoSize = 'bigger';
          } else if (this.userInfo.client_id === 200) {
            this.theme = 'hardrock';
            this.companyLogo = 'assets/theme/hardrock/logo-center.svg';
            this.companyLogoSmall = 'assets/theme/hardrock/logo.svg';
            this.companyLogoBottom = 'assets/theme/hardrock/logo-bottom.svg';
            this.companyHeader = 'hardrock';
            this.companyLogoSize = 'bigger';
          } else if (this.userInfo.client_id === 70) {
            this.theme = 'macmillan';
            this.companyLogo = 'assets/theme/macmillan/macmillan-logo.svg';
            this.companyLogoSmall = 'assets/icon/alchemist-logo.svg';
            this.companyLogoBottom = null;
            this.companyHeader = 'macmillan';
            this.companyLogoSize = 'default';
            this.headerMode = 'light';
          }
        }
        this.event.publish('auth:getUserInfo', this.userInfo);
        return data.result;
      })
      .catch(e => {
        console.log('Error getCurrentUserInfo >> ', e);
      });
  }

  getCurrentUserInfo(redirectHome = true) {
    if (this.userInfo === null && redirectHome) {
      this.navCtrl.navigateRoot('/home');
    }
    return this.userInfo;
  }

  getUserDelegateTemplate(): JourneyDelegateTemplateModel {
    return this.userDelegateTemplate;
  }

  setUserDelegateTemplate(template_id) {
    this.userDelegateTemplate = null;
    if (this.userInfo.templates && this.userInfo.templates.length > 0) {
      this.userDelegateTemplate = this.userInfo.templates.find((o) => o.template_id === template_id) || null;
    }
    if (this.userInfo.templates && this.userDelegateTemplate === null && !!this.userInfo.template_id) {
      this.userDelegateTemplate = this.userInfo.templates.find((o) => o.template_id === this.userInfo.template_id) || null;
    }
    if (this.userDelegateTemplate === null) {
      this.userTemplateId = null;
      this.userDelegateTemplate = null;
    } else {
      localStorage.setItem('userTemplateId[' + this.hash + ']', template_id);
      this.userTemplateId = template_id;
    }
  }

  switchJourney(template_id) {
    return this.requesterService.put('switchJourney', {template_id})
      .then(data => data.result)
      .catch(e => {
        console.error('Error in: switchJourney', e);
        return null;
      });
  }

  getUsersList(keywords: string, limit: number = 10): Promise<DelegateSimpleModel[]> {
    return this.requesterService.get('getUsersList', {keywords, limit})
      .then(data => {
        if (!!data.result) {
          return data.result;
        }
        return [];
      })
      .catch(e => {
        console.log('Error getUsersList >> ', e);
      });
  }

  getMyHBMagicLink(url): Promise<any> {
    return this.requesterService.get('getMyHBMagicLink', {url})
      .then(data => {
        if (!!data.result) {
          return data.result;
        }
        return null;
      })
      .catch(e => {
        return null;
        console.log('Error getMyHBMagicLink >> ', e);
      });
  }

  getAllowedScenarios() {
    const scenarios = [
      {
        scenario_id: 1,
        template_id: 534,
      },
      {
        scenario_id: 2,
        template_id: 535,
      },
      {
        scenario_id: 3,
        template_id: 545,
      },
      {
        scenario_id: 4,
        template_id: 548,
      },
      {
        scenario_id: 5,
        template_id: 550,
      },
      {
        scenario_id: 6,
        template_id: 549,
      },
      {
        scenario_id: 7,
        template_id: 547,
      },
      {
        scenario_id: 8,
        template_id: 546,
      },
      {
        scenario_id: 1,
        template_id: 652,
      },
      {
        scenario_id: 2,
        template_id: 696,
      },
    ];
    const templates = this.userInfo.templates || [];

    return scenarios.filter((scenario) => {
      const template = templates.find((t) => t.template_id === scenario.template_id);
      return !!template;
    }).map((scenario => scenario.scenario_id));
  }

  async acceptConsent(): Promise<void> {
    return this.requesterService.post('acceptConsent', {}).then(() => {});
  }
}
